import './TripAdvisor.css';
import React from 'react';
import LazyPicture from '../LazyPicture';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
var TripAdvisor = function TripAdvisor(_ref) {
  var imageRatingSRC = _ref.imageRatingSRC,
    score = _ref.score,
    alt = _ref.alt,
    tripadvisorReviews = _ref.tripadvisorReviews,
    tripadvisorPrice = _ref.tripadvisorPrice,
    reviewCaption = _ref.reviewCaption;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  if (!imageRatingSRC || imageRatingSRC === undefined || imageRatingSRC === '') return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-tripAdvisor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-tripAdvisor__left"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "p-tripadvisor"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imageRatingSRC
  }), /*#__PURE__*/React.createElement("img", {
    className: "rating-img",
    src: imageRatingSRC,
    alt: alt,
    title: score
  })), tripadvisorReviews && /*#__PURE__*/React.createElement("strong", {
    className: "c-tripAdvisor__reviews"
  }, Number(tripadvisorReviews).toLocaleString(), " ", reviewCaption)), tripadvisorPrice && /*#__PURE__*/React.createElement("span", {
    className: "c-tripAdvisor__price"
  }, tripadvisorPrice), tripadvisorPrice && /*#__PURE__*/React.createElement("span", {
    style: {
      width: '47px;'
    }
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "c1j7jg9";
var ltrStyles = "lvpxnzf";
var rtlStyles = "rwh89zg";
export default TripAdvisor;